module.exports = __webpack_public_path__ + "img/attackoriginal.6eadd751.png";